export default {
    greetYou () {
        let now = new Date();
        let hour = now.getHours();
        let str = '';
        if(hour < 6){str = "凌晨咯~ 要注意休息呢~ 我会陪着你的"} 
        else if (hour < 9){str = "早上好！今天也要元气满满呀~"} 
        else if (hour < 12){str = "上午好！加油干，马上吃午饭啦~"} 
        else if (hour < 14){str = "中午好！休息一会不~，下午不犯困"} 
        else if (hour < 17){str = "下午好！累了就点一次下午茶犒劳自己吧~"} 
        else if (hour < 19){str = "傍晚好！早点去休息哟~"} 
        else if (hour < 22){str = "晚上好！一个人也要好好爱自己呢~"} 
        else {str = "夜深了！早点去睡觉~"} 
        return str;
    },
    // 获取name by id
    getNameById (id, arr, props = ['id', 'name']) {
        for (let item of arr) {
            if (item[props[0]] == id) {
                return item[props[1]]
            }
        }
        return '--'
    },
    // 获取类型
    getType (index) {
        let typeArr = ['', 'success', 'warning', 'danger', 'info'];
        return typeArr[index]
    },
    // 获取周几
    getWeekText (arr) {
        if (arr.length == 0) {
            return '--';
        }
        let strArr = [];
        for (let item of arr) {
            strArr.push(this.getWeeksSeveral(item))
        }
        return '每' + strArr.join('、')
    },
    // 获取周几
    getWeeksSeveral (item) {
        let wordArr = ['一', '二', '三', '四', '五', '六', '日'];
        return '周' + wordArr[item - 1]
    },
    // 格式化中国标准时间
    formatTimeToyyyymmdd (d, connector = '-') {
        var month = d.getMonth() + 1; 
        month = month < 10 ? "0" + month : month;
        return d.getFullYear() + connector + month + connector + d.getDate();
    },
    formatNumber(number, decimals = 2, dec_point = '.', thousands_sep = ',') {
        /*
        * 参数说明：
        * number：要格式化的数字
        * decimals：保留几位小数
        * dec_point：小数点符号
        * thousands_sep：千分位符号
        * */
        number = (number + '').replace(/[^0-9+-Ee.]/g, '');
        var n = !isFinite(+number) ? 0 : +number,
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
            s = '',
            toFixedFix = function (n, prec) {
                var k = Math.pow(10, prec);
                var nk = (n * k).toFixed(2);
                return '' + Math.floor(nk) / k;
            };
        s = (prec ? toFixedFix(n, prec) : '' + Math.floor(n)).split('.');
        var re = /(-?\d+)(\d{3})/;
        while (re.test(s[0])) {
            s[0] = s[0].replace(re, "$1" + sep + "$2");
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec);
    },
}


// WEBPACK FOOTER //
// ./src/utils/utils.js